import React, { Component } from "react";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import ShipmentsTableContainer from "./_ShipmentTable";
import OrdersByShipmentContainer from "../Orders/Table/_OrdersByShipmentTable";
import {
  switchTableComponent,
  toggleArchivedShipments
} from "../../actions/ui_actions";

import TablesSwitchButton from "../../common/Buttons/_TablesSwitchButton";

class Shipment extends Component {
  componentWillMount() {
    this.props.switchTableComponent("shipment");
  }

  componentWillUnmount() {
    this.props.switchTableComponent();
  }

  render() {
    const { visibleTableComponent } = this.props;

    return (
      <Box flex>
        {visibleTableComponent === "shipment" && <ShipmentsTableContainer />}
        {visibleTableComponent === "order" && (
          <Box flex>
            <Box m={1}>
              <TablesSwitchButton componentType="toShipment" />
            </Box>
            <OrdersByShipmentContainer />
          </Box>
        )}
      </Box>
    );
  }
}

const mapStateToProps = state => {
  return {
    visibleTableComponent: state.ui.visibleTableComponent
  };
};

export default connect(mapStateToProps, {
  switchTableComponent: switchTableComponent,
  toggleArchivedShipments: toggleArchivedShipments
})(Shipment);



// WEBPACK FOOTER //
// ./src/views/Shipments/index.js